import { InjectionToken } from "@angular/core";
import { ApplicationInsights, IConfig, IConfiguration } from "@microsoft/applicationinsights-web";
import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

export interface EnvironmentConfig {
  production: boolean;
  debugMode: boolean;
  logToConsole: boolean | '#{{ENABLE_LOGGING}}#';
  environmentName: 'dev' | 'uat' | 'prod' | 'local' | '#{{CLIENT_ENVIRONMENT}}#',
  appVersion: string,
  registration: AzureAd;
  appInsights: IConfiguration & IConfig,
  endpoints: {
    baseApi: { url: string, version: string },
    local: { url: string, version: string },
    sealingElementsApi: { url: string, version: string },
    oRingsApi: { url: string, version: string }
  },
  containers: {
    drawings: string
  },
  modalOptions: NgbModalOptions,
  closureImgReference: {
    le14: {
      left: {
        flange: string,
        noFlange: string
      },
      right: {
        flange: string,
        noFlange: string
      }
    },
    gt15lt32: {
      left: {
        flange: string,
        noFlange: string
      },
      right: {
        flange: string,
        noFlange: string
      }
    },
    actuated24to30: {
      left: {
        flange: string,
        noFlange: string
      },
      right: {
        flange: string,
        noFlange: string
      }
    },
    gt32: {
      left: {
        flange: string,
        noFlange: string
      },
      right: {
        flange: string,
        noFlange: string
      }
    }
  }
}

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>('EnvironmentConfig');
export const APP_INSIGHTS = new InjectionToken<ApplicationInsights>('AppInsights');


export interface AzureAd {
  scopeUri?: string[];
  tenantId?: string;
  uiClientId?: string;
  redirectUrl?: string;
  protectedResources?: [string, string[]][] | Map<string, Array<string>>;
}
